/* OBSIDIANA v3 — comportamientos: stepper de cantidad, barra de compra fija,
   búsqueda predictiva, header con sombra y sincronización del badge del carrito. */
(function () {
  'use strict';

  /* ── Financiación seQura nativa: actualiza el importe (precio÷3) al cambiar de variante ── */
  (function () {
    var amountEl = document.querySelector('[data-ob-finance-amount]');
    var priceSrc = document.getElementById('sequra-price');
    var btn = document.querySelector('[data-ob-finance]');
    var trigger = document.querySelector('.ob-finance__trigger');
    if (!amountEl || !priceSrc) return;
    function eur(n) {
      return n.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    }
    function sync() {
      var p = parseFloat(String(priceSrc.textContent).replace(',', '.'));
      if (!isNaN(p) && p > 0) {
        amountEl.textContent = eur(p / 3);
        /* data-amount en céntimos para el simulador de seQura */
        if (trigger) trigger.setAttribute('data-amount', Math.round(p * 100));
      }
    }
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(priceSrc, { childList: true, characterData: true, subtree: true });
    }
    sync();
    /* Al pulsar la línea visible, abrimos el modal educativo de seQura
       clicando el disparador oculto (seQura enlaza su click). */
    if (btn && trigger) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var t = trigger.querySelector('a, button') || trigger;
        t.click();
      });
    }
  })();

  /* ── Recomendaciones personalizadas + historial de productos vistos ──
     1) "Creemos que te va a gustar" usa el motor de recomendaciones de Shopify
        (compras conjuntas reales de la tienda) en vez de una colección fija.
     2) Guarda los productos vistos por ESTE usuario (localStorage) y los
        muestra en la sección "Vistos recientemente". ── */
  (function () {
    var KEY = 'ms_recent_products';
    var MAX = 12;

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    }

    function cardHTML(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && img.indexOf('?') === -1) img += '?width=660';
      else if (img) img += '&width=660';
      var price = typeof p.price === 'number' ? money(p.price) : (p.price_formatted || '');
      var compare = (typeof p.compare_at_price === 'number' && p.compare_at_price > p.price)
        ? '<span class="becay-product-card__price-compare">' + money(p.compare_at_price) + '</span>' : '';
      var art = document.createElement('article');
      art.className = 'becay-product-card';
      art.innerHTML =
        '<div class="becay-product-card__media-wrap">' +
          '<a href="' + p.url + '" class="becay-product-card__link">' +
            '<div class="becay-product-card__media">' +
              (img ? '<img class="becay-product-card__image" src="' + img + '" alt="" loading="lazy" decoding="async">' : '') +
            '</div>' +
          '</a>' +
        '</div>' +
        '<a href="' + p.url + '" class="becay-product-card__body-link">' +
          '<div class="becay-product-card__body">' +
            '<h3 class="becay-product-card__title"></h3>' +
            '<div class="becay-product-card__price">' +
              '<span class="becay-product-card__price-current' + (compare ? ' becay-product-card__price-current--sale' : '') + '">' + price + '</span>' +
              compare +
            '</div>' +
          '</div>' +
        '</a>';
      art.querySelector('.becay-product-card__title').textContent = p.title;
      return art;
    }

    /* 1) Recomendaciones reales de Shopify para esta ficha */
    var recoGrid = document.querySelector('[data-ob-reco]');
    if (recoGrid) {
      var pid = recoGrid.getAttribute('data-product-id');
      var lim = parseInt(recoGrid.getAttribute('data-limit'), 10) || 4;
      if (pid) {
        fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + lim + '&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var prods = (data && data.products) || [];
            if (prods.length < 2) return; /* pocas: dejamos el fallback del tema */
            recoGrid.innerHTML = '';
            prods.forEach(function (p) { recoGrid.appendChild(cardHTML(p)); });
          })
          .catch(function () { /* silencioso: se queda el fallback */ });
      }
    }

    /* 2) Guardar el producto actual en el historial del usuario */
    var pdp = document.querySelector('[data-becay-product]');
    if (pdp && window.__obProduct) {
      try {
        var cur = window.__obProduct;
        var list = JSON.parse(localStorage.getItem(KEY) || '[]');
        list = list.filter(function (x) { return x && x.url !== cur.url; });
        list.unshift(cur);
        localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
      } catch (e) {}
    }

    /* 3) Pintar "Vistos recientemente" (excluyendo el producto actual) */
    var recentSection = document.querySelector('[data-ob-recent]');
    if (recentSection) {
      var grid = recentSection.querySelector('[data-ob-recent-grid]');
      var here = location.pathname.split('?')[0];
      var items = [];
      try { items = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
      items = items.filter(function (x) { return x && x.url && x.url.split('?')[0] !== here; }).slice(0, 4);
      if (items.length >= 2) {
        items.forEach(function (p) { grid.appendChild(cardHTML(p)); });
        recentSection.hidden = false;
      }
    }
  })();

  /* ── Stepper de cantidad en ficha de producto ── */
  document.querySelectorAll('[data-ob-qty]').forEach(function (box) {
    var input = box.querySelector('[data-qty-input]');
    var minus = box.querySelector('[data-ob-qty-minus]');
    var plus = box.querySelector('[data-ob-qty-plus]');
    if (!input) return;
    function step(delta) {
      var v = parseInt(input.value, 10) || 1;
      v = Math.min(99, Math.max(1, v + delta));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
      if (v > 99) input.value = 99;
    });
  });

  /* ── Barra de compra fija en móvil ── */
  var stickybar = document.querySelector('[data-ob-stickybar]');
  if (stickybar) {
    var addBtn = document.querySelector('.becay-product__buybox [data-add-to-cart-button]');
    var form = addBtn ? addBtn.closest('form') : null;
    if (addBtn && 'IntersectionObserver' in window) {
      stickybar.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        var pastBuybox = entries[0].boundingClientRect.top < 0;
        stickybar.classList.toggle('is-visible', !visible && pastBuybox);
      }, { threshold: 0 });
      io.observe(addBtn);

      var stickyAdd = stickybar.querySelector('[data-ob-stickybar-add]');
      if (stickyAdd && form) {
        stickyAdd.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else addBtn.click();
        });
      }
      /* Sincronizar precio al cambiar de variante */
      var priceSource = document.querySelector('[data-price-current]');
      var priceTarget = stickybar.querySelector('[data-ob-stickybar-price]');
      if (priceSource && priceTarget && 'MutationObserver' in window) {
        new MutationObserver(function () {
          priceTarget.textContent = priceSource.textContent;
        }).observe(priceSource, { childList: true, characterData: true, subtree: true });
      }
    }
  }

  /* ── Sombra del header al hacer scroll ── */
  var onScroll = function () {
    document.documentElement.classList.toggle('ob-header-stuck', window.scrollY > 8);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Burbuja deslizante de la navegación inferior (estilo iOS) ── */
  var bottomNav = document.querySelector('.ob-bottomnav');
  if (bottomNav) {
    if (location.pathname.indexOf('/search') === 0) {
      var searchTab = bottomNav.querySelector('[data-becay-search-toggle]');
      if (searchTab) searchTab.classList.add('is-active');
    }
    var bubble = document.createElement('span');
    bubble.className = 'ob-bottomnav__bubble';
    bubble.setAttribute('aria-hidden', 'true');
    bottomNav.prepend(bubble);
    var navItems = [].slice.call(bottomNav.querySelectorAll('.ob-bottomnav__item'));

    function moveBubble(el, instant) {
      if (!el) { bubble.style.opacity = '0'; return; }
      var navRect = bottomNav.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      if (instant) bubble.style.transition = 'none';
      bubble.style.opacity = '1';
      bubble.style.width = (r.width - 10) + 'px';
      bubble.style.transform = 'translateX(' + (r.left - navRect.left + 5) + 'px)';
      if (instant) { void bubble.offsetWidth; bubble.style.transition = ''; }
    }

    var activeTab = bottomNav.querySelector('.ob-bottomnav__item.is-active');
    if (document.readyState === 'complete') moveBubble(activeTab, true);
    else window.addEventListener('load', function () { moveBubble(bottomNav.querySelector('.ob-bottomnav__item.is-active'), true); });
    window.addEventListener('resize', function () {
      moveBubble(bottomNav.querySelector('.ob-bottomnav__item.is-active'), true);
    });

    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        /* El carrito abre un modal, no cambia de página: la burbuja no se mueve */
        if (item.hasAttribute('data-cart-open-drawer')) return;
        navItems.forEach(function (o) { o.classList.remove('is-active'); });
        item.classList.add('is-active');
        moveBubble(item, false);
      });
    });

    /* ── Arrastre estilo iOS: la burbuja sigue al dedo y selecciona al soltar ── */
    var dragState = { active: false, moved: false, startX: 0, peek: null };

    function itemAtX(x) {
      for (var i = 0; i < navItems.length; i++) {
        var r = navItems[i].getBoundingClientRect();
        if (x >= r.left && x <= r.right) return navItems[i];
      }
      return null;
    }

    function clearPeek() {
      if (dragState.peek) { dragState.peek.classList.remove('is-peek'); dragState.peek = null; }
    }

    bottomNav.addEventListener('touchstart', function (e) {
      dragState.active = true;
      dragState.moved = false;
      dragState.startX = e.touches[0].clientX;
    }, { passive: true });

    bottomNav.addEventListener('touchmove', function (e) {
      if (!dragState.active) return;
      var x = e.touches[0].clientX;
      if (!dragState.moved && Math.abs(x - dragState.startX) < 8) return;
      dragState.moved = true;
      e.preventDefault();
      var target = itemAtX(x);
      if (target && target !== dragState.peek) {
        clearPeek();
        dragState.peek = target;
        target.classList.add('is-peek');
        bubble.classList.add('is-dragging');
        moveBubble(target, false);
      }
    }, { passive: false });

    bottomNav.addEventListener('touchend', function (e) {
      if (!dragState.active) return;
      var wasDrag = dragState.moved;
      var target = dragState.peek;
      dragState.active = false;
      dragState.moved = false;
      bubble.classList.remove('is-dragging');
      clearPeek();
      if (!wasDrag) return; /* tap normal: lo gestiona el click nativo */
      e.preventDefault();
      if (!target) {
        moveBubble(bottomNav.querySelector('.ob-bottomnav__item.is-active'), false);
        return;
      }
      if (target.hasAttribute('data-cart-open-drawer')) {
        moveBubble(bottomNav.querySelector('.ob-bottomnav__item.is-active'), false);
        target.click();
        return;
      }
      navItems.forEach(function (o) { o.classList.remove('is-active'); });
      target.classList.add('is-active');
      moveBubble(target, false);
      if (target.tagName === 'A' && target.href) window.setTimeout(function () { location.href = target.href; }, 120);
      else target.click();
    }, { passive: false });

    bottomNav.addEventListener('touchcancel', function () {
      dragState.active = false;
      dragState.moved = false;
      bubble.classList.remove('is-dragging');
      clearPeek();
      moveBubble(bottomNav.querySelector('.ob-bottomnav__item.is-active'), false);
    });
  }

  /* ── Badge del carrito en la navegación inferior ── */
  var headerCount = document.querySelector('.becay-header__cart-count');
  var navBadges = document.querySelectorAll('[data-ob-cart-count]');
  if (headerCount && navBadges.length && 'MutationObserver' in window) {
    var syncBadge = function () {
      var n = parseInt(headerCount.textContent.trim(), 10) || 0;
      headerCount.classList.toggle('is-empty', n === 0);
      navBadges.forEach(function (b) {
        b.textContent = n;
        b.hidden = n === 0;
      });
    };
    new MutationObserver(syncBadge).observe(headerCount, { childList: true, characterData: true, subtree: true });
    syncBadge();
  }

  /* ── Filtros: todos los chips a la vista (sin carril horizontal oculto) ── */
  document.querySelectorAll('.becay-collection__vendor-filters, .becay-collection__tag-filters').forEach(function (list) {
    function unlock() {
      /* la base fija altura/anchura de carril por JS y CSS: la soltamos */
      list.style.setProperty('height', 'auto', 'important');
      list.style.setProperty('max-height', 'none', 'important');
      list.style.setProperty('width', 'auto', 'important');
      list.style.setProperty('overflow', 'visible', 'important');
      list.style.setProperty('flex-wrap', 'wrap', 'important');
      var track = list.closest('.becay-collection__vendor-track');
      if (track) {
        track.style.setProperty('overflow', 'visible', 'important');
        track.style.setProperty('height', 'auto', 'important');
      }
    }
    unlock();
    if (document.readyState !== 'complete') window.addEventListener('load', unlock);
    window.addEventListener('resize', unlock);

    /* En móvil solo se ven 5 chips (CSS): botón para desplegar el resto */
    function buildMoreBtn() {
      if (window.innerWidth > 749) return;
      if (list.querySelector('.ob-filters-more')) return;
      var chips = list.querySelectorAll(':scope > a');
      if (chips.length <= 5) return;
      /* la primera chip es "Todas": el contador cuenta solo las ocultas */
      var etiqueta = '+' + (chips.length - 5) + ' más';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ob-filters-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span></span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.querySelector('span').textContent = etiqueta;
      list.appendChild(btn);
      btn.addEventListener('click', function () {
        var open = list.classList.toggle('ob-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.querySelector('span').textContent = open ? 'Menos' : etiqueta;
      });
    }
    if (document.readyState === 'complete') buildMoreBtn();
    else window.addEventListener('load', buildMoreBtn);
    /* si el tema vuelve a fijar estilos, los soltamos de nuevo */
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].attributeName === 'style' && list.style.maxHeight !== 'none') { unlock(); break; }
        }
      }).observe(list, { attributes: true, attributeFilter: ['style'] });
    }
  });

  /* Móvil: la descripción de colección empujaba los productos ~110px hacia abajo.
     Se recorta a 3 líneas con "Leer más" (el texto sigue íntegro en el DOM). */
  (function () {
    var desc = document.querySelector('.becay-collection__description');
    if (!desc || window.innerWidth > 749) return;
    if (desc.scrollHeight <= desc.clientHeight + 4) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ob-desc-more';
    btn.textContent = 'Leer más';
    btn.setAttribute('aria-expanded', 'false');
    desc.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('ob-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Leer menos' : 'Leer más';
    });
  })();

  /* ── Textos SEO (colección y home): plegado con "Leer más" ── */
  document.querySelectorAll('.becay-collection__seo-copy-content, .home-seo-copy .becay-product__info-copy').forEach(function (el) {
    if (el.scrollHeight <= 300) return;
    el.classList.add('ob-clamp');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ob-readmore';
    btn.textContent = 'Leer más';
    btn.setAttribute('aria-expanded', 'false');
    el.parentElement.appendChild(btn);
    btn.addEventListener('click', function () {
      var clamped = el.classList.toggle('ob-clamp');
      btn.textContent = clamped ? 'Leer más' : 'Leer menos';
      btn.setAttribute('aria-expanded', String(!clamped));
    });
  });

  /* ── seQura: el tema y la app cargan el widget por duplicado; dejamos UNO ──
     El script de la app puede clonar nuestro propio contenedor (clase incluida),
     así que no basta con filtrar por clase: conservamos el primer contenedor
     sequra RAÍZ del formulario y, dentro de él, el primer bloque visible. ── */
  var pform = document.querySelector('[data-becay-product-form]');
  if (pform && 'MutationObserver' in window) {
    var dedupeSequra = function () {
      var nodes = pform.querySelectorAll('[class*="sequra"], [id*="sequra"]');
      var roots = [];
      nodes.forEach(function (c) {
        if (!c.parentElement) return;
        if (c.parentElement.closest('[class*="sequra"], [id*="sequra"]')) return;
        roots.push(c);
      });
      roots.forEach(function (r, i) {
        if (i > 0 && r.style.display !== 'none') r.style.display = 'none';
      });
      var main = roots[0];
      if (main) {
        var visibleKids = [].filter.call(main.children, function (k) {
          return getComputedStyle(k).display !== 'none';
        });
        visibleKids.slice(1).forEach(function (k) { k.style.display = 'none'; });
      }
    };
    new MutationObserver(dedupeSequra).observe(pform, { childList: true, subtree: true });
    dedupeSequra();
  }

  /* ── Espejo del estado del carrito en <body> (fallback de :has) ── */
  var drawer = document.querySelector('.becay-cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    var syncDrawerState = function () {
      document.body.classList.toggle('ob-cart-open', drawer.classList.contains('is-open'));
    };
    new MutationObserver(syncDrawerState).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncDrawerState();
  }

  /* ── Botón Buscar de la navegación inferior ── */
  document.querySelectorAll('.ob-bottomnav [data-becay-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (location.pathname !== '/search') location.href = '/search?type=product';
      else {
        var pi = document.querySelector('.becay-search-page__input');
        if (pi) pi.focus();
      }
    });
  });

  /* ── Búsqueda predictiva (overlay del header + página /search) ── */
  function money(price) {
    var n = typeof price === 'string' ? parseFloat(price) : price;
    if (isNaN(n)) return '';
    return n.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function attachSuggest(searchInput, suggestBox) {
    var list = suggestBox.querySelector('[data-ob-suggest-list]');
    var allLink = suggestBox.querySelector('[data-ob-suggest-all]');
    var populares = suggestBox.parentElement.querySelector('[data-ob-populares]');
    var timer = null;
    var lastQuery = '';

    function togglePopulares() {
      if (populares) populares.hidden = searchInput.value.trim().length >= 2;
    }
    togglePopulares();

    function render(products, query) {
      list.innerHTML = '';
      if (!products.length) { suggestBox.hidden = true; return; }
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'ob-suggest__item';
        a.href = p.url;
        a.setAttribute('role', 'option');
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=88';
        a.innerHTML =
          (img ? '<img class="ob-suggest__img" loading="lazy" src="' + img + '" alt="">' : '<span class="ob-suggest__img"></span>') +
          '<span class="ob-suggest__meta">' +
          '<span class="ob-suggest__title"></span>' +
          '<span class="ob-suggest__price">' + money(p.price) + '</span>' +
          '</span>';
        a.querySelector('.ob-suggest__title').textContent = p.title;
        list.appendChild(a);
      });
      if (allLink) {
        allLink.href = '/search?type=product&q=' + encodeURIComponent(query);
        allLink.hidden = false;
      }
      suggestBox.hidden = false;
    }

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(timer);
      togglePopulares();
      if (q.length < 2) { suggestBox.hidden = true; return; }
      timer = setTimeout(function () {
        lastQuery = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (q !== lastQuery) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, q);
          })
          .catch(function () { suggestBox.hidden = true; });
      }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!suggestBox.contains(e.target) && e.target !== searchInput) suggestBox.hidden = true;
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') suggestBox.hidden = true;
    });
  }

  document.querySelectorAll('[data-becay-search-input], [data-ob-suggest-input]').forEach(function (input) {
    var scope = input.closest('form') ? input.closest('form').parentElement : document;
    var box = scope.querySelector('[data-ob-suggest]');
    if (box) attachSuggest(input, box);
  });
})();
